import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import CancleConfirm from './cancel_confirm';

describe('CancleConfirm', () => {
  test('renders CancleConfirm component', () => {
    const tickets = [{ id: 1, name: "100枚チケット", unit_price: 1100, count: 1, total_price: 1100 }, { id: 2, name: "200枚チケット", unit_price: 2200, count: 2, total_price: 4400 }]
    render(<CancleConfirm tickets={tickets} total_price={5500} refund_fee={-1000} />);

    screen.debug();

    // タイトル
    expect(screen.getByText('キャンセル内容')).toBeInTheDocument();
    expect(screen.getByText('以下の内容でキャンセルの申請を確定します。')).toBeInTheDocument();

    // ヘッダ部分
    expect(screen.getByText('チケット名')).toBeInTheDocument();
    expect(screen.getByText('キャンセル数')).toBeInTheDocument();
    expect(screen.getByText('価格')).toBeInTheDocument();
    expect(screen.getByText('返金額')).toBeInTheDocument();

    // レコード
    expect(screen.getByText('100枚チケット')).toBeInTheDocument();
    expect(screen.getByText('200枚チケット')).toBeInTheDocument();

    expect(screen.getByText('小計')).toBeInTheDocument();
    expect(screen.getByText('消費税(10%)')).toBeInTheDocument();
    expect(screen.getByText('キャンセル手数料')).toBeInTheDocument();
    expect(screen.getByText('合計')).toBeInTheDocument();

  });
});
